import { FC, forwardRef, useImperativeHandle, useState } from 'react';
import { useMethods } from '@lhb/hook';
// import styles from './index.module.less';
import { Modal } from 'antd';
import BrandListChart from './BrandListChart';

/**
 * 汽车上险量-品牌上险量图表弹窗
 * @description
 * @demo
 */
const Component:FC<{
  listData: any[];
  ref?: any,
}> = forwardRef(({ listData }, ref) => {

  useImperativeHandle(ref, () => ({
    init: methods.init,
  }));

  /* state */
  const [visible, setVisible] = useState(false);

  /* hooks */

  /* methods */
  const methods = useMethods({

    init() {
      setVisible(true);
    },

  });

  return (<Modal
    open={visible}
    width={448}
    centered={true}
    title='品牌上险量'
    footer={null}
    onCancel={() => setVisible(false)}
  >
    <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
      <BrandListChart listData={listData} />
    </div>
  </Modal>);
});

export default Component;
